module.exports = __webpack_public_path__ + "static/clients-ihg.25601434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/clients-ihg.png
// module id = 930
// module chunks = 241767136424496